export default __webpack_public_path__ + "static/media/selectedGrid.4cac8443.png";